import React from "react";

type InputType = {
  placeholder: string;
  value: string;
  onChange: (inputValue: string) => void;
  max?: number;
  min?: number;
  type?: string;
  name?: string;
  required?: boolean;
  className?: string;
};

const CustomInput = ({
  placeholder,
  value,
  onChange,
  max,
  min,
  required,
  type,
  name,
  className,
}: InputType) => {
  const updatedPlaceholder = required ? `${placeholder} *` : placeholder;

  return (
    <input
      name={name}
      type={type ? type : "text"}
      placeholder={updatedPlaceholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      maxLength={max}
      minLength={min}
      required={required}
      className="input input-bordered min-w-full mb-4 rounded-none"
    />
  );
};

export default CustomInput;
